var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-modal"},[_c('div',{staticClass:"message-modal__body"},[_c('div',{staticClass:"message-modal__text"},[_vm._t("default")],2),_c('FormButton',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Закрыть")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }